// extracted by mini-css-extract-plugin
export default {"save-button":"save-button_save-button__XCqyD"};